import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-tclc-history',
  templateUrl: './tclc-history.component.html',
  styleUrls: ['./tclc-history.component.scss']
})
export class TclcHistoryComponent implements OnInit {
 // datePipe: DatePipe = new DatePipe('en-US');
 SctHist: FormGroup;
 submitpayload: any;
 submitButton = true;
 editButton = false;
 showSubmitButton = true;
 APIService: any;
 ScrutinyTable: [];
 StudentId = 0;
 dialogRef: MatDialogRef<any>;
 date: any;
 time: any;
 sctLvl = 0;
 // jsonData: any;
 constructor(public umsService: UmsService,
   public dialogRef1: MatDialogRef<TclcHistoryComponent>,
   private fb: FormBuilder, public router: Router, 
   
   private datePipe: DatePipe,@Inject(MAT_DIALOG_DATA) public data: any,
 ) { this.APIService = environment.serviceUrl; }
 convertUTCToIST(dateString: string): string {
   const utcDate = new Date(dateString); // Convert string to Date object
   const istDate = new Date(utcDate.getTime() - (330 * 60 * 1000)); // IST is UTC + 5:30
   return this.datePipe.transform(istDate, 'dd/MM/yyyy h:mm:ss a', 'Asia/Kolkata') || '';
 }


 ngOnInit(): void {
  this.StudentId = this.data['StudentId']
   this.submitButton = true;
   this.editButton = false;
   this.SctHist = this.fb.group({

   });
   this.getData();
 }

 
 
 getData() {
   const payload = {};
   payload['CertType'] = this.data['CertType'];
   payload['StuId'] = this.data['StuId'];
   this.umsService.GetCertScr(payload).subscribe((res) => {
     // this.spinner.hide();
     if (res.status) {
       this.ScrutinyTable = res.data;
     } else {
       if(res.message == 'No Data Found'){
         this.ScrutinyTable = [];
       }
     }
   });
 }


 close() {
   this.dialogRef1.close();
 }

}



